import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountComponent } from './account.component';
import { AccountBillParamsComponent } from './routes/account-bill-params/account-bill-params.component';
import { AccountBillParamsGuard } from './routes/account-bill-params/account-bill-params.guard';
import { AccountInformationsComponent } from './routes/account-informations/account-informations.component';
import { AccountMsdpLinkComponent } from './routes/account-msdp-link/account-msdp-link.component';
import { AccountPasswordComponent } from './routes/account-password/account-password.component';
import { AccountSubscriptionComponent } from './routes/account-subscription/account-subscription.component';

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'informations' },
      {
        path: 'informations',
        component: AccountInformationsComponent,
        loadChildren: () =>
          import(
            './routes/account-informations/account-informations.module'
          ).then((m) => m.AccountInformationsModule),
      },
      {
        path: 'password',
        component: AccountPasswordComponent,
        loadChildren: () =>
          import('./routes/account-password/account-password.module').then(
            (m) => m.AccountPasswordModule,
          ),
      },
      {
        path: 'subscription',
        component: AccountSubscriptionComponent,
        loadChildren: () =>
          import(
            './routes/account-subscription/account-subscription.module'
          ).then((m) => m.AccountSubscriptionModule),
      },
      {
        path: 'msdpLink',
        component: AccountMsdpLinkComponent,
        loadChildren: () =>
          import('./routes/account-msdp-link/account-msdp-link.module').then(
            (m) => m.AccountMsdpLinkModule,
          ),
      },
      {
        path: 'billParams',
        component: AccountBillParamsComponent,
        canActivate: [AccountBillParamsGuard],
        loadChildren: () =>
          import(
            './routes/account-bill-params/account-bill-params.module'
          ).then((m) => m.AccountBillParamsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
